module.exports = __webpack_public_path__ + "static/media/Agri-Retailers Infographic Desktop 05-02-2024 C.19b1c7c2.gif";